"use client";

import NewUser from "@components/User/New";
import { NextPage } from "next";
import { useEffect } from "react";

interface NewUserPageProps {
  groupId?: string;
}

const NewUserPage: NextPage<NewUserPageProps> = ({ groupId }) => {
  // TODO: Legacy Rails client center app integration
  // Check if parent window has profile_window_loaded function and execute it on mount
  useEffect(() => {
    if (window.parent && window.parent !== window) {
      try {
        // @ts-ignore - Legacy function may not be typed
        if (typeof window.parent.profile_window_loaded === "function") {
          // @ts-ignore
          window.parent.profile_window_loaded();
        }
      } catch (e) {
        // Cross-origin access may fail, ignore silently
      }
    }
  }, []);

  return <NewUser groupId={groupId} />;
};

export default NewUserPage;
